var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8571 0H1.14286C0.510714 0 0 0.48439 0 1.08395V22.7629C0 23.3625 0.510714 23.8469 1.14286 23.8469H30.8571C31.4893 23.8469 32 23.3625 32 22.7629V1.08395C32 0.48439 31.4893 0 30.8571 0ZM27.9714 3.68881L16.7036 12.0047C16.425 12.2114 16.0357 12.2114 15.7571 12.0047L4.48571 3.68881C4.44322 3.65771 4.41206 3.61478 4.39659 3.56604C4.38112 3.5173 4.38212 3.46518 4.39944 3.417C4.41677 3.36882 4.44955 3.32699 4.49321 3.29738C4.53686 3.26776 4.58919 3.25184 4.64286 3.25185H27.8143C27.868 3.25184 27.9203 3.26776 27.9639 3.29738C28.0076 3.32699 28.0404 3.36882 28.0577 3.417C28.075 3.46518 28.076 3.5173 28.0606 3.56604C28.0451 3.61478 28.0139 3.65771 27.9714 3.68881Z",
    fill: "#EDD9A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.096a200cb69a2c848f7e588eac0bdf25.svg";
export { ForwardRef as ReactComponent };